document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const initHwdTheme = () => {
  if (window.lucide) {
    window.lucide.createIcons({
      attrs: {
        'stroke-width': 1.5,
      },
    });
  }
  window.HWD_THEME_READY = true;

  const suppressKlaviyoPopups = () => {
    document.querySelectorAll('[role="dialog"][aria-label="POPUP Form"], form.klaviyo-form-version-cid_1').forEach((node) => {
      const root = node.closest('body > div.needsclick') || node.closest('[role="dialog"]') || node;
      root.setAttribute('hidden', '');
      root.style.display = 'none';
      root.style.pointerEvents = 'none';
    });
  };

  const suppressPurchaseLimitNotice = () => {
    document.querySelectorAll('.pol-m, .pol-i').forEach((node) => {
      node.setAttribute('hidden', '');
      node.style.display = 'none';
      node.style.visibility = 'hidden';
      node.style.pointerEvents = 'none';
    });
    document.querySelectorAll('.pol-i-li1-t, .pol-i-li3-s').forEach((node) => {
      const text = (node.textContent || '').trim();
      if (/Cannot place order|conditions not met|^OK$/.test(text)) node.textContent = '';
    });
  };

  const suppressInjectedNoise = () => {
    suppressKlaviyoPopups();
    suppressPurchaseLimitNotice();
  };

  const cleanPolicyCopy = () => {
    if (!window.location.pathname.startsWith('/policies/')) return;

    const replacements = [
      ['QR ' + 'Flask', 'His Word Daily'],
      ['QR ' + 'flask', 'His Word Daily'],
      ['qr ' + 'flask', 'His Word Daily'],
      ['QR Connect', 'His Word Daily'],
      ['QR CONNECT', 'HIS WORD DAILY'],
      ['Welcome to His Word Daily !', 'Welcome to His Word Daily.'],
      ['His Word Daily .', 'His Word Daily.'],
      ['His Word Daily ,', 'His Word Daily,'],
      ['His Word Daily ’', 'His Word Daily’'],
      ['Privacy Policy [LINK]', 'Privacy Policy'],
      ['Refund Policy [LINK]', 'Refund Policy'],
      ['Privacy Policy, which can be viewed here ,', 'Privacy Policy,'],
      ['Privacy Policy, which can be viewed here,', 'Privacy Policy,'],
      ['[LINK]', ''],
      [
        'We have a 30-day return policy, which means you have 30 days after receiving your item to request a return.',
        "Returns are accepted within 30 days. We want every order to land well. If something arrives broken, doesn't fit, or just isn't right, email us and we'll make it right. The 30-day policy in plain terms: 30 days after receiving your item to request a return.",
      ],
      ['joshuakorth3459' + '@gmail.com', 'hello@hisworddaily.com'],
      ['[INSERT RETURN ADDRESS]', 'His Word Daily, 1703 West Jackson Street, Painesville, OH 44077, United States'],
    ];

    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: (node) => {
          const parent = node.parentElement;
          if (!parent || ['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA'].includes(parent.tagName)) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        },
      },
    );

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      let value = node.nodeValue;
      replacements.forEach(([from, to]) => {
        value = value.split(from).join(to);
      });
      if (value !== node.nodeValue) node.nodeValue = value;
    });

    if (window.location.pathname === '/policies/terms-of-service') {
      document.querySelectorAll('.shopify-policy__body p, .shopify-policy__body li, main p, main li').forEach((el) => {
        const html = el.innerHTML
          .replace('our Privacy Policy, and certain personal information', 'our <a href="/policies/privacy-policy">Privacy Policy</a>, and certain personal information')
          .replace('our Refund Policy.', 'our <a href="/policies/refund-policy">Refund Policy</a>.');
        if (html !== el.innerHTML) el.innerHTML = html;
      });
    }

    document.querySelectorAll('a[href^="mailto:"]').forEach((link) => {
      if (link.href.includes('joshuakorth3459' + '@gmail.com')) {
        link.href = 'mailto:hello@hisworddaily.com';
      }
    });
  };

  cleanPolicyCopy();
  setTimeout(cleanPolicyCopy, 600);
  setTimeout(cleanPolicyCopy, 1800);
  suppressInjectedNoise();
  setTimeout(suppressInjectedNoise, 600);
  setTimeout(suppressInjectedNoise, 1800);
  new MutationObserver(() => {
    cleanPolicyCopy();
    suppressInjectedNoise();
  }).observe(document.body, { childList: true, subtree: true });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHwdTheme);
} else {
  initHwdTheme();
}

const HWD_BUNDLES = [
  {
    handle: 'full-faith-bundle',
    label: 'Full Faith',
    variantId: 46848159285332,
    priceCents: 15999,
    components: ['tumbler', 'hoodie', 't-shirt', 'bracelet', 'stickers'],
  },
  {
    handle: 'daily-rhythm-bundle',
    label: 'Daily Rhythm',
    variantId: 46848159252564,
    priceCents: 9999,
    components: ['tumbler', 't-shirt', 'bracelet', 'stickers'],
  },
  {
    handle: 'starter-bundle',
    label: 'Starter',
    variantId: 46848159187028,
    priceCents: 6499,
    components: ['tumbler', 'bracelet', 'stickers'],
  },
];

const HWD_BUNDLE_COVERAGE = {
  'full-faith-bundle': ['tumbler', 'hoodie', 't-shirt', 'bracelet', 'stickers'],
  'daily-rhythm-bundle': ['tumbler', 't-shirt', 'bracelet', 'stickers'],
  'starter-bundle': ['tumbler', 'bracelet', 'stickers'],
  tumbler: ['tumbler'],
  hoodie: ['hoodie'],
  't-shirt': ['t-shirt'],
  bracelet: ['bracelet'],
  stickers: ['stickers'],
};

const hwdCoverageForHandle = (handle) => HWD_BUNDLE_COVERAGE[handle] || [];

const hwdMoney = (cents) => `$${(Number(cents || 0) / 100).toFixed(2)}`;
const hwdBundleVariantCache = {};
let hwdAutoBundleApplying = false;

const resolveBundleVariantId = async (bundle) => {
  if (hwdBundleVariantCache[bundle.handle]) return hwdBundleVariantCache[bundle.handle];
  try {
    const response = await fetch(`/products/${bundle.handle}.js`, { headers: { Accept: 'application/json' } });
    if (response.ok) {
      const product = await response.json();
      const variantId = Number(product?.variants?.[0]?.id);
      if (variantId) {
        hwdBundleVariantCache[bundle.handle] = variantId;
        return variantId;
      }
    }
  } catch (_) {
    // Fall through to the static id below.
  }
  return bundle.variantId;
};

const openCartDrawer = () => {
  const drawer = document.querySelector('[data-hwd-cart-drawer]');
  const overlay = document.querySelector('[data-hwd-cart-overlay]');
  if (!drawer || !overlay) return false;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  overlay.removeAttribute('hidden');
  document.body.classList.add('hwd-cart-open');
  return true;
};

const closeCartDrawer = () => {
  const drawer = document.querySelector('[data-hwd-cart-drawer]');
  const overlay = document.querySelector('[data-hwd-cart-overlay]');
  drawer?.classList.remove('is-open');
  drawer?.setAttribute('aria-hidden', 'true');
  overlay?.setAttribute('hidden', '');
  document.body.classList.remove('hwd-cart-open');
};

const getCart = async () => {
  const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Cart read failed');
  return response.json();
};

const refreshCartDrawer = async (open = true) => {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 8000);
  let response;
  try {
    response = await fetch(`/?sections=cart-drawer&hwd_cart=${Date.now()}`, {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      signal: controller.signal,
    });
  } finally {
    window.clearTimeout(timeout);
  }
  if (!response.ok) return;
  const sections = await response.json();
  const html = sections['cart-drawer'];
  if (!html) return;
  const wrapper = document.createElement('div');
  wrapper.innerHTML = html;
  const nextSection = wrapper.querySelector('#shopify-section-cart-drawer');
  const currentSection = document.querySelector('#shopify-section-cart-drawer');
  if (nextSection && currentSection) currentSection.replaceWith(nextSection);
  initHwdTheme();
  renderBundleOpportunity();
  if (open) openCartDrawer();
};

const serializeProperties = (form) => {
  const properties = {};
  const data = new FormData(form);
  for (const [key, value] of data.entries()) {
    const match = key.match(/^properties\[(.+)]$/);
    if (match && value) properties[match[1]] = value;
  }
  return properties;
};

const addCartItem = async (item) => {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(item),
  });
  if (!response.ok) throw new Error('Cart add failed');
  return response.json();
};

const fireCartAdd = (item) => {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(item),
  }).catch((error) => console.error(error));
};

const changeCartLine = async (key, quantity) => {
  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ id: key, quantity }),
  });
  if (!response.ok) throw new Error('Cart change failed');
  return response.json();
};

const changeCartLineNumber = async (line, quantity) => {
  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ line, quantity }),
  });
  if (!response.ok) throw new Error('Cart line change failed');
  return response.json();
};

const updateCartLines = async (updates) => {
  const response = await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ updates }),
  });
  if (!response.ok) throw new Error('Cart update failed');
  return response.json();
};

const normalizeBraceletColor = (value = '') => {
  const lower = value.toLowerCase();
  if (lower.includes('gold')) return 'White band, gold cross';
  if ((lower.includes('bone') || lower.includes('white')) && (lower.includes('black') || lower.includes('ink'))) {
    return 'White band, ink cross';
  }
  if (lower.includes('black band') || lower.includes('ink band')) return 'Ink band, white cross';
  if (lower.includes('black') || lower.includes('ink')) return 'Ink band, white cross';
  return value || 'White band, gold cross';
};

const cartLineHandle = (item) => {
  const fromUrl = (item.url || '').match(/\/products\/([^/?#]+)/)?.[1];
  const fromTitle = (item.product_title || item.title || '')
    .toLowerCase()
    .replace(/^the\s+/, '')
    .replace(/his word daily\s+/g, '')
    .replace(/\s+bundle$/g, '-bundle')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
  return item.handle || item.product_handle || fromUrl || fromTitle;
};

const variantText = (item) => {
  return Array.from(new Set([
    item.variant_title,
    ...(item.options_with_values || []).map((option) => option.value),
  ].filter(Boolean))).join(' ');
};

const bundlePropertiesFromLines = (bundle, lines) => {
  const properties = {
    _bundle_label: bundle.label,
    _bundle_handle: bundle.handle,
    _bundle_auto_applied: 'Converted from matching cart items',
  };
  const stickerCounts = {
    'starter-bundle': '3 stickers',
    'daily-rhythm-bundle': '5 stickers',
    'full-faith-bundle': '10 stickers',
  };
  if (stickerCounts[bundle.handle]) properties['Stickers included'] = stickerCounts[bundle.handle];
  lines.forEach((line) => {
    const text = variantText(line);
    const handle = cartLineHandle(line);
    if (handle === 'tumbler') properties['Tumbler color'] = line.properties?.['Tumbler color'] || text || 'Black';
    if (handle === 'bracelet') properties['Bracelet color'] = line.properties?.['Bracelet color'] || normalizeBraceletColor(text);
    if (handle === 'hoodie') properties['Hoodie size'] = line.properties?.['Hoodie size'] || line.properties?.Size || text || 'M';
    if (handle === 't-shirt') properties['T-shirt size'] = line.properties?.['T-shirt size'] || line.properties?.Size || text || 'M';
  });
  return properties;
};

const findBestBundle = (cart) => {
  if (!cart?.items?.length) return null;
  if (cart.items.some((item) => HWD_BUNDLES.some((bundle) => bundle.handle === cartLineHandle(item)))) return null;
  for (const bundle of HWD_BUNDLES) {
    const matched = [];
    const used = new Set();
    for (const handle of bundle.components) {
      const line = cart.items.find((item) => cartLineHandle(item) === handle && Number(item.quantity) > 0 && !used.has(item.key));
      if (!line) break;
      matched.push(line);
      used.add(line.key);
    }
    if (matched.length === bundle.components.length) return { bundle, lines: matched };
  }
  return null;
};

const hwdCartWithLineNumbers = (cart) => ({
  ...cart,
  items: (cart.items || []).map((item, index) => ({
    ...item,
    line: item.line || index + 1,
  })),
});

const convertSinglesToBundle = async (match) => {
  if (!match) return false;
  const variantId = await resolveBundleVariantId(match.bundle);
  await addCartItem({
    id: variantId,
    quantity: 1,
    properties: bundlePropertiesFromLines(match.bundle, match.lines),
  });
  let currentCart = null;
  for (let attempt = 0; attempt < 12; attempt += 1) {
    await new Promise((resolve) => setTimeout(resolve, 300));
    currentCart = hwdCartWithLineNumbers(await getCart());
    if (currentCart.items.some((item) => cartLineHandle(item) === match.bundle.handle)) break;
  }
  if (!currentCart || !currentCart.items.some((item) => cartLineHandle(item) === match.bundle.handle)) {
    throw new Error('Bundle add did not appear in cart');
  }
  const matchedKeys = new Set(match.lines.map((line) => line.key).filter(Boolean));
  const removals = currentCart.items.filter((item) => matchedKeys.has(item.key));
  if (removals.length) {
    const updates = {};
    removals.forEach((item) => {
      updates[item.key] = Math.max(0, Number(item.quantity) - 1);
    });
    await updateCartLines(updates);
  }
  return true;
};

const renderBundleOpportunityPrompt = (match) => {
  if (!match) return;
  const retail = match.lines.reduce((sum, line) => sum + Number(line.final_line_price || line.line_price || 0) / Number(line.quantity || 1), 0);
  const savings = Math.max(0, retail - match.bundle.priceCents);
  const node = document.createElement('div');
  node.className = 'hwd-bundle-opportunity';
  node.setAttribute('data-hwd-bundle-opportunity', match.bundle.handle);
  node.innerHTML = `
    <div>
      <span class="hwd-eyebrow">Bundle pricing found</span>
      <p class="small">Your cart matches the ${match.bundle.label} bundle. Apply bundle pricing before checkout and save ${hwdMoney(savings)}.</p>
    </div>
    <button class="hwd-button hwd-button--primary" type="button" data-hwd-apply-bundle-pricing="${match.bundle.handle}">Apply ${match.bundle.label} pricing · ${hwdMoney(match.bundle.priceCents)}</button>
  `;
  const drawerTarget = document.querySelector('[data-hwd-cart-drawer] .hwd-cart-upsell');
  const pageTarget = document.querySelector('.hwd-cart-page .hwd-cart-lines');
  if (drawerTarget) drawerTarget.before(node.cloneNode(true));
  if (pageTarget) pageTarget.after(node);
};

const renderBundleOpportunity = async () => {
  if (window.HWD_CART_DEDUPING) return;
  document.querySelectorAll('[data-hwd-bundle-opportunity]').forEach((node) => node.remove());
  let cart;
  try {
    cart = hwdCartWithLineNumbers(await getCart());
  } catch (_) {
    return;
  }
  let match = findBestBundle(cart);
  for (let attempt = 0; attempt < 6 && !match && window.location.pathname === '/cart'; attempt += 1) {
    await new Promise((resolve) => setTimeout(resolve, 500));
    cart = hwdCartWithLineNumbers(await getCart());
    match = findBestBundle(cart);
  }
  if (!match) return;
  if (hwdAutoBundleApplying || window.HWD_CART_AUTO_BUNDLE_RUNNING) return;
  window.HWD_CART_AUTO_BUNDLE_RUNNING = true;
  hwdAutoBundleApplying = true;
  try {
    await convertSinglesToBundle(match);
    if (window.location.pathname === '/cart') {
      window.location.reload();
    } else {
      await refreshCartDrawer(false);
    }
  } catch (error) {
    console.error(error);
    renderBundleOpportunityPrompt(match);
  } finally {
    hwdAutoBundleApplying = false;
    window.HWD_CART_AUTO_BUNDLE_RUNNING = false;
  }
};

const submitHwdProductForm = async (form) => {
  const bundleForm = form.closest('[data-hwd-bundle-form]');
  const button = form.querySelector('button[type="submit"]');
  const originalLabel = button?.textContent;
  if (button) {
    button.disabled = true;
    button.textContent = bundleForm ? 'Adding bundle' : 'Adding';
  }
  try {
    if (bundleForm && bundleForm.dataset.bundleMode === 'sku') {
      const properties = serializeProperties(bundleForm);
      properties._bundle_label = bundleForm.dataset.bundleLabel || 'HWD';
      properties._bundle_handle = bundleForm.dataset.bundleHandle || '';
      await addCartItem({
        id: Number(bundleForm.dataset.bundleVariantId || bundleForm.querySelector('[name="id"]')?.value),
        quantity: 1,
        properties,
      });
    } else {
      const data = new FormData(form);
      const properties = serializeProperties(form);
      await addCartItem({
        id: Number(data.get('id')),
        quantity: Number(data.get('quantity') || 1),
        properties,
      });
      // Bundle conversion is handled on the cart surface where the customer can see the final offer.
    }
    if (window.location.pathname === '/cart') {
      window.location.reload();
    } else {
      window.location.href = '/cart';
    }
  } catch (error) {
    console.error(error);
    alert('Something went wrong adding that. Try again, or refresh the page.');
  } finally {
    if (button) {
      button.disabled = false;
      button.textContent = originalLabel || 'Add to cart';
    }
  }
};

const openImageViewer = (image) => {
  const images = Array.from(document.querySelectorAll('.hwd-pdp__main-image img, .hwd-pdp__thumb img, .hwd-mosaic__tile img'))
    .map((img) => ({ src: img.currentSrc || img.src, alt: img.alt || '' }))
    .filter((item, index, list) => item.src && list.findIndex((other) => other.src === item.src) === index);
  if (!images.length) return;
  let index = Math.max(0, images.findIndex((item) => item.src === (image.currentSrc || image.src)));
  const viewer = document.createElement('div');
  viewer.className = 'hwd-image-viewer';
  viewer.innerHTML = `
    <button type="button" class="hwd-image-viewer__close" data-hwd-image-viewer-close aria-label="Close image">×</button>
    <button type="button" class="hwd-image-viewer__nav hwd-image-viewer__nav--prev" data-hwd-image-viewer-prev aria-label="Previous image">‹</button>
    <img alt="">
    <button type="button" class="hwd-image-viewer__nav hwd-image-viewer__nav--next" data-hwd-image-viewer-next aria-label="Next image">›</button>
  `;
  const render = () => {
    const img = viewer.querySelector('img');
    img.src = images[index].src;
    img.alt = images[index].alt;
  };
  viewer.hwdImages = images;
  viewer.hwdIndex = index;
  viewer.hwdRender = () => {
    index = viewer.hwdIndex;
    render();
  };
  render();
  document.body.appendChild(viewer);
  document.body.classList.add('hwd-cart-open');
};

document.addEventListener('DOMContentLoaded', renderBundleOpportunity);

const setMobileMenuOpen = (open) => {
  const menu = document.querySelector('[data-hwd-mobile-menu]');
  const toggle = document.querySelector('[data-hwd-menu-toggle]');
  if (!menu || !toggle) return;
  menu.toggleAttribute('hidden', !open);
  toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  document.body.classList.toggle('hwd-menu-open', open);
};

let lastMobileMenuGesture = 0;

const interceptMobileMenuGesture = (event) => {
  const toggle = event.target.closest?.('[data-hwd-menu-toggle]');
  if (!toggle) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const now = Date.now();
  if (event.type !== 'pointerdown' && event.type !== 'touchstart' && now - lastMobileMenuGesture < 700) {
    return;
  }
  if (now - lastMobileMenuGesture < 250) {
    return;
  }

  lastMobileMenuGesture = now;
  const menu = document.querySelector('[data-hwd-mobile-menu]');
  setMobileMenuOpen(menu?.hasAttribute('hidden'));
};

['pointerdown', 'touchstart', 'pointerup', 'touchend', 'click'].forEach((eventName) => {
  document.addEventListener(eventName, interceptMobileMenuGesture, true);
});

document.addEventListener('click', (event) => {
  const menuToggle = event.target.closest('[data-hwd-menu-toggle]');
  if (menuToggle) {
    const menu = document.querySelector('[data-hwd-mobile-menu]');
    const isOpen = menu && !menu.hasAttribute('hidden');
    event.preventDefault();
    setMobileMenuOpen(!isOpen);
  } else if (!event.target.closest('[data-hwd-mobile-menu]') && document.querySelector('[data-hwd-mobile-menu]:not([hidden])')) {
    setMobileMenuOpen(false);
  }

  const cartLink = event.target.closest('a[href="/cart"]');
  if (cartLink && openCartDrawer()) {
    event.preventDefault();
  }

  const cartClose = event.target.closest('[data-hwd-cart-close], [data-hwd-cart-overlay]');
  if (cartClose) {
    closeCartDrawer();
  }

  const plus = event.target.closest('[data-hwd-qty-plus]');
  const minus = event.target.closest('[data-hwd-qty-minus]');
  if (plus || minus) {
    const control = event.target.closest('[data-hwd-qty]');
    const value = control?.querySelector('[data-hwd-qty-value]');
    if (!value) return;
    const next = Number(value.textContent) + (plus ? 1 : -1);
    const clean = Math.max(1, Math.min(10, next));
    value.textContent = clean;
    const form = control.closest('form');
    const input = form?.querySelector('[data-hwd-quantity-input]');
    if (input) input.value = clean;
  }

  const choice = event.target.closest('[data-hwd-choice]');
  if (choice) {
    const group = choice.closest('[role="group"]');
    group?.querySelectorAll('[data-hwd-choice]').forEach((item) => {
      item.setAttribute('aria-pressed', item === choice ? 'true' : 'false');
    });
  }

  const productChoice = event.target.closest('[data-hwd-product-choice]');
  if (productChoice) {
    const form = productChoice.closest('[data-hwd-product-form]');
    const variantInput = form?.querySelector('[data-hwd-variant-id]');
    const price = document.querySelector('[data-hwd-product-price]');
    const cta = form?.querySelector('[data-hwd-atc]');
    const choiceName = document.querySelector('[data-hwd-choice-name]');
    productChoice.closest('[role="group"]')?.querySelectorAll('[data-hwd-product-choice]').forEach((item) => {
      item.setAttribute('aria-pressed', item === productChoice ? 'true' : 'false');
    });
    if (variantInput) variantInput.value = productChoice.dataset.variantId;
    if (price) price.textContent = productChoice.dataset.price;
    if (cta) cta.textContent = `Add to cart · ${productChoice.dataset.price}`;
    if (choiceName) choiceName.textContent = productChoice.dataset.choiceName;
    if (productChoice.dataset.hwdChoiceImage) {
      const mainImage = document.querySelector('[data-hwd-product-main] img');
      if (mainImage) mainImage.src = productChoice.dataset.hwdChoiceImage;
    }
  }

  const sizeChoice = event.target.closest('[data-hwd-size-choice]');
  if (sizeChoice && !sizeChoice.disabled) {
    const scope = sizeChoice.closest('.hwd-bundle-choice') || sizeChoice.closest('[data-hwd-product-form]');
    const sizeInput = scope?.querySelector('[data-hwd-size-property]');
    sizeChoice.closest('[role="group"]')?.querySelectorAll('[data-hwd-size-choice]').forEach((item) => {
      item.setAttribute('aria-pressed', item === sizeChoice ? 'true' : 'false');
    });
    if (sizeInput) sizeInput.value = sizeChoice.value;
  }

  const braceletChoice = event.target.closest('.hwd-bracelet-tile[data-hwd-choice]');
  if (braceletChoice) {
    const scope = braceletChoice.closest('.hwd-bundle-choice');
    const input = scope?.querySelector('[data-hwd-bracelet-property]');
    if (input) input.value = braceletChoice.textContent.trim();
    const summary = scope?.querySelector('summary .small');
    if (summary) summary.textContent = braceletChoice.textContent.trim();
    if (braceletChoice.dataset.hwdChoiceImage) {
      const firstBundleImage = document.querySelector('.hwd-mosaic__tile:first-child img');
      if (firstBundleImage) firstBundleImage.src = braceletChoice.dataset.hwdChoiceImage;
    }
  }

  const bundleSizeChoice = event.target.closest('[data-hwd-size-choice]');
  if (bundleSizeChoice && bundleSizeChoice.closest('.hwd-bundle-choice')) {
    const scope = bundleSizeChoice.closest('.hwd-bundle-choice');
    const summary = scope?.querySelector('summary .small');
    if (summary) summary.textContent = bundleSizeChoice.value;
  }

  const tumblerChoice = event.target.closest('[data-hwd-tumbler-choice]');
  if (tumblerChoice) {
    const scope = tumblerChoice.closest('.hwd-bundle-choice');
    const input = scope?.querySelector('[data-hwd-tumbler-property]');
    tumblerChoice.closest('[role="group"]')?.querySelectorAll('[data-hwd-tumbler-choice]').forEach((item) => {
      item.setAttribute('aria-pressed', item === tumblerChoice ? 'true' : 'false');
    });
    if (input) input.value = tumblerChoice.value;
    const summary = scope?.querySelector('summary .small');
    if (summary) summary.textContent = tumblerChoice.value;
    if (tumblerChoice.dataset.hwdChoiceImage) {
      const firstBundleImage = document.querySelector('.hwd-mosaic__tile:first-child img');
      if (firstBundleImage) firstBundleImage.src = tumblerChoice.dataset.hwdChoiceImage;
    }
  }

  const thumb = event.target.closest('[data-hwd-thumb]');
  if (thumb) {
    const main = document.querySelector('[data-hwd-product-main] img');
    if (main) main.src = thumb.dataset.hwdThumb;
  }

  const image = event.target.closest('.hwd-pdp__main-image img, .hwd-mosaic__tile img');
  if (image) openImageViewer(image);

  const viewerClose = event.target.closest('[data-hwd-image-viewer-close]');
  if (viewerClose || event.target.classList.contains('hwd-image-viewer')) {
    event.target.closest('.hwd-image-viewer')?.remove();
    document.body.classList.remove('hwd-cart-open');
  }

  const viewerNav = event.target.closest('[data-hwd-image-viewer-prev], [data-hwd-image-viewer-next]');
  if (viewerNav) {
    const viewer = viewerNav.closest('.hwd-image-viewer');
    if (viewer?.hwdImages?.length) {
      const direction = viewerNav.matches('[data-hwd-image-viewer-prev]') ? -1 : 1;
      viewer.hwdIndex = (viewer.hwdIndex + direction + viewer.hwdImages.length) % viewer.hwdImages.length;
      viewer.hwdRender();
    }
  }

  const applyBundle = event.target.closest('[data-hwd-apply-bundle-pricing]');
  if (applyBundle) {
    event.preventDefault();
    applyBundle.disabled = true;
    applyBundle.textContent = 'Applying bundle pricing';
    getCart()
      .then((cart) => convertSinglesToBundle(findBestBundle(cart)))
      .then(() => {
        if (window.location.pathname === '/cart') window.location.reload();
        else refreshCartDrawer(true);
      })
      .catch((error) => {
        console.error(error);
        applyBundle.disabled = false;
        applyBundle.textContent = 'Apply bundle pricing';
      });
  }

  const checkout = event.target.closest('[data-hwd-checkout]');
  if (checkout) {
    event.preventDefault();
    checkout.textContent = 'Checking bundle pricing';
    getCart()
      .then(async (cart) => {
        const match = findBestBundle(cart);
        if (match) await convertSinglesToBundle(match);
        window.location.href = '/checkout';
      })
      .catch(() => {
        window.location.href = '/checkout';
      });
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') setMobileMenuOpen(false);
});

document.addEventListener('toggle', (event) => {
  const details = event.target;
  if (!details.matches('[data-hwd-faq] details') || !details.open) return;
  details.parentElement.querySelectorAll('details').forEach((item) => {
    if (item !== details) item.removeAttribute('open');
  });
}, true);

const updateStickyAtc = () => {
  const header = document.querySelector('[data-hwd-header]');
  if (header) header.classList.toggle('is-scrolled', window.scrollY > 120);
  const stickyAtc = document.querySelector('[data-hwd-sticky-atc]');
  const buybox = document.querySelector('#product-buybox');
  if (stickyAtc && buybox) {
    const stickyBlocker = Array.from(document.querySelectorAll('.hwd-fbt, .hwd-cross-bundle, .hwd-final-cta, .hwd-related, .hwd-trust-strip')).some((section) => {
      const rect = section.getBoundingClientRect();
      return rect.top < window.innerHeight - 88 && rect.bottom > 96;
    });
    const shouldShow = window.matchMedia('(max-width: 767px)').matches && buybox.getBoundingClientRect().bottom < 0 && !stickyBlocker;
    stickyAtc.toggleAttribute('hidden', !shouldShow);
  }
};

window.addEventListener('scroll', updateStickyAtc, { passive: true });
window.addEventListener('resize', updateStickyAtc, { passive: true });
window.addEventListener('load', updateStickyAtc);

document.addEventListener('submit', async (event) => {
  const newsletter = event.target.closest('[data-hwd-newsletter]');
  if (newsletter) {
    event.preventDefault();
    const success = newsletter.parentElement?.querySelector('[data-hwd-newsletter-success]');
    const button = newsletter.querySelector('button[type="submit"], [type="submit"]');
    if (button) button.textContent = 'Subscribed';
    success?.removeAttribute('hidden');
    newsletter.setAttribute('aria-live', 'polite');
    return;
  }

  const form = event.target.closest('[data-hwd-product-form]');
  if (!form) return;
  event.preventDefault();
  await submitHwdProductForm(form);
});
